import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, withKeys as _withKeys, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withCtx as _withCtx, vShow as _vShow, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, Teleport as _Teleport, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-337cf725"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ModalSyosiList_Content" }
const _hoisted_2 = { class: "ModalSyosiList_Header" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ModalSyosiList_Header_Title" }, "書誌検索", -1))
const _hoisted_4 = { class: "ModalSyosiList_Main" }
const _hoisted_5 = { class: "ModalSyosiList_SearchContainer" }
const _hoisted_6 = { class: "ModalSyosiList_SearchForm" }
const _hoisted_7 = { class: "ModalSyosiList_SearchForm_Left" }
const _hoisted_8 = { class: "ModalSyosiList_SearchForm_Item" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "フリーワード :", -1))
const _hoisted_10 = { class: "ModalSyosiList_SearchForm_Item" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "発売日 :", -1))
const _hoisted_12 = { class: "ModalSyosiList_SearchForm_Right" }
const _hoisted_13 = { class: "ModalSyosiList_SearchForm_Item" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "カテゴリ :", -1))
const _hoisted_15 = ["value"]
const _hoisted_16 = { class: "ModalSyosiList_SearchForm_Item" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "種別 :", -1))
const _hoisted_18 = ["value"]
const _hoisted_19 = { class: "paging_container" }
const _hoisted_20 = {
  key: 0,
  class: "ModalSyosiList_Operation"
}
const _hoisted_21 = { class: "ModalSyosiList_Operation_Allcheck" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "all-check" }, "全選択", -1))
const _hoisted_23 = ["checked"]
const _hoisted_24 = { class: "ModalSyosiList_TableContainer" }
const _hoisted_25 = { class: "ModalSyosiList_Table" }
const _hoisted_26 = { key: 0 }
const _hoisted_27 = { key: 1 }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, [
  /*#__PURE__*/_createTextVNode("書誌CD"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("ISBN13桁"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("出版社書誌CD")
], -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "ModalSyosiList_Table_Syoten" }, "書誌名", -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, [
  /*#__PURE__*/_createTextVNode("在庫"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("断裁")
], -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "発売日", -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "カテゴリ", -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "種別", -1))
const _hoisted_34 = { key: 0 }
const _hoisted_35 = { key: 0 }
const _hoisted_36 = ["onUpdate:modelValue"]
const _hoisted_37 = { key: 1 }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_40 = { class: "ModalSyosiList_Table_Syoten" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_42 = {
  key: 1,
  class: "ResultMessageNull"
}

import { onMounted, ref, watch } from "vue";
import BtnGreenSmall from "../atoms/button/BtnGreenSmall.vue";
import BtnGreen from "../atoms/button/BtnGreen.vue";
// import InputText from "../atoms/Input/InputText.vue";
import { useStore } from "vuex";
import Paginate from "vuejs-paginate-next";
import { useRoute } from "vue-router";
import { Notyf } from "notyf";
import { ZaikoData } from "@/types/zaiko";

export interface ZaikoData_Result extends ZaikoData {
  selectFlg: boolean;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'ModalSyosiList',
  props: {
  ikkatuFlg: {
    type: Boolean,
    default: false,
  },
},
  emits: ["close", "ref_selectSyosi", "ref_selectMultiSyosi"],
  setup(__props, { emit: __emit }) {

const store = useStore();
const route = useRoute();
const emit = __emit;
//propsの定義
const props = __props;
const notyf = new Notyf();
onMounted(() => {
  console.log(props.ikkatuFlg);
});

// モーダルの検索条件初期化（ストア）------------------------------------------------
store.commit("search/resetSyosiDetailState");

//検索条件設定用
// eslint-disable-next-line no-unused-vars
let searchConditions = ref({
  syubetu: "",
  category: "",
  fromDate: "",
  toDate: "",
  zaikoStatus: "",
  searchWord: "",
});
// テーブル表示項目----------------------------------------------
let search_result = ref<ZaikoData_Result[]>([]);

const closeModal = () => {
  emit("close");
};

//検索条件更新
watch(searchConditions.value, () => {
  store.commit("search/setSyosiDetailState", searchConditions.value);
});
//種別
const syubetuList = store.getters["constant/getSyubetuList"];
//カテゴリ
const categoryList = store.getters["constant/getCategoryList"];

//書店検索
const onSearch = () => {
  store.commit("search/resetPage");
  currentPage.value = 1;
  getSyosiData();
};
const getSyosiData = async (): Promise<void> => {
  search_result.value.splice(0);
  await store.dispatch("search/searchSyosi");
  const res = store.getters["search/getSyosiData"];
  res.syosiList.forEach((syosi: ZaikoData) => {
    search_result.value.push({ selectFlg: false, ...syosi });
  });
  numberOfTotalData.value = res.size;
  firstCount.value = res.firstCount;
  finalCount.value = res.finalCount;
  getTotalPage();
};
onMounted(() => {
  onSearch();
});

//書店選択-------------------------------
// 単独選択
const selectSyosi = (syosi: ZaikoData) => {
  if (window.confirm(`${syosi.title}を選択してもよろしいですか？`)) {
    emit("ref_selectSyosi", syosi);
    closeModal();
  }
};
// 一括選択
const isCheckAll = ref(false);
const allCheck = ref();
const checkAll = (e: any) => {
  search_result.value.forEach((result) => {
    result.selectFlg = e.target.checked;
  });
};
const selectMultiSyosi = () => {
  if (search_result.value.filter((syosi) => syosi.selectFlg).length === 0) {
    notyf.error("書誌が選択されていません");
  } else {
    if (window.confirm(`選択された書誌を反映します。よろしいですか？`)) {
      const multiSyosi: ZaikoData_Result[] = [];
      search_result.value.forEach((syosi) => {
        if (syosi.selectFlg) multiSyosi.push(syosi);
      });
      emit("ref_selectMultiSyosi", multiSyosi);
      closeModal();
    }
  }
};
// ページネーション関連処理-----------------------------------------
// 取得データ合計
let numberOfTotalData = ref(0);
// 1ページあたりの表示データ数(一旦固定)
let dataPerPage = 100;
// 総ページ数
const numberOfTotalPage = ref(0);
//表示中のページ範囲
let firstCount = ref(0);
let finalCount = ref(0);

// 現在のページ数
const currentPage = ref(1);
const getTotalPage = () => {
  numberOfTotalPage.value = Math.ceil(numberOfTotalData.value / dataPerPage);
};
const onClickPage = (newPage: number) => {
  currentPage.value = newPage;
  store.commit("search/setPageNumber", currentPage.value);
  getSyosiData();
  isCheckAll.value = false;
  allCheck.value.checked = false;
};

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createElementVNode("div", {
      class: "ModalSyosiList",
      onClick: closeModal
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createVNode(_component_font_awesome_icon, {
          onClick: closeModal,
          class: "ModalSyosiList_Header_Close",
          icon: "xmark"
        })
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "ModalSyosiList_SearchForm_Input InputText",
                  placeholder: "書誌名/書誌CDを入力してください",
                  onKeydown: _withKeys(onSearch, ["enter"]),
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(searchConditions).searchWord) = $event))
                }, null, 544), [
                  [_vModelText, _unref(searchConditions).searchWord]
                ])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _hoisted_11,
                _withDirectives(_createElementVNode("input", {
                  type: "date",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(searchConditions).fromDate) = $event)),
                  class: "ModalSyosiList_SearchForm_Date"
                }, null, 512), [
                  [_vModelText, _unref(searchConditions).fromDate]
                ]),
                _createTextVNode("～"),
                _withDirectives(_createElementVNode("input", {
                  type: "date",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(searchConditions).toDate) = $event)),
                  class: "ModalSyosiList_SearchForm_Date"
                }, null, 512), [
                  [_vModelText, _unref(searchConditions).toDate]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _hoisted_14,
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(searchConditions).category) = $event)),
                  class: "ModalSyosiList_SearchForm_Select"
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(categoryList), (option, index) => {
                    return (_openBlock(), _createElementBlock("option", {
                      value: option.categoryCd,
                      key: index
                    }, _toDisplayString(option.category), 9, _hoisted_15))
                  }), 128))
                ], 512), [
                  [_vModelSelect, _unref(searchConditions).category]
                ])
              ]),
              _createElementVNode("div", _hoisted_16, [
                _hoisted_17,
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(searchConditions).syubetu) = $event)),
                  class: "ModalSyosiList_SearchForm_Select"
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(syubetuList), (option, index) => {
                    return (_openBlock(), _createElementBlock("option", {
                      value: option.syubetu,
                      key: index
                    }, _toDisplayString(option.syubetu), 9, _hoisted_18))
                  }), 128))
                ], 512), [
                  [_vModelSelect, _unref(searchConditions).syubetu]
                ])
              ])
            ])
          ]),
          _createVNode(BtnGreen, {
            class: "ModalSyosiList_BtnGreen",
            onClickBtn: onSearch
          }, {
            default: _withCtx(() => [
              _createVNode(_component_font_awesome_icon, {
                class: "ModalSyosiList_SearchIcon",
                icon: "search"
              }),
              _createTextVNode(" 検索")
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_19, [
          _createVNode(_unref(Paginate), {
            "page-count": numberOfTotalPage.value,
            "hide-prev-next": true,
            "page-range": 3,
            "prev-text": '<',
            "next-text": '>',
            "container-class": 'pagination',
            "page-class": 'page-item',
            "page-link-class": 'page-item--link',
            "active-class": 'page-item--active',
            "click-handler": onClickPage,
            "force-page": currentPage.value
          }, null, 8, ["page-count", "force-page"]),
          _withDirectives(_createElementVNode("span", { class: "paging_result" }, " 検索結果：" + _toDisplayString(_unref(numberOfTotalData)) + "件/" + _toDisplayString(_unref(firstCount)) + "～" + _toDisplayString(_unref(finalCount)) + "件を表示", 513), [
            [_vShow, _unref(search_result).length]
          ])
        ]),
        (__props.ikkatuFlg)
          ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _hoisted_22,
                _createElementVNode("input", {
                  type: "checkbox",
                  id: "all-check",
                  checked: isCheckAll.value,
                  onChange: checkAll,
                  ref_key: "allCheck",
                  ref: allCheck
                }, null, 40, _hoisted_23)
              ]),
              _createVNode(BtnGreenSmall, {
                onClick: selectMultiSyosi,
                class: "ModalSyosiList_BtnGreenSmall"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("一括選択")
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("table", _hoisted_25, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                (__props.ikkatuFlg)
                  ? (_openBlock(), _createElementBlock("th", _hoisted_26))
                  : _createCommentVNode("", true),
                (!(_unref(route).path.includes('/newPreOrderList') && __props.ikkatuFlg))
                  ? (_openBlock(), _createElementBlock("th", _hoisted_27, " 選択 "))
                  : _createCommentVNode("", true),
                _hoisted_28,
                _hoisted_29,
                _hoisted_30,
                _hoisted_31,
                _hoisted_32,
                _hoisted_33
              ])
            ]),
            (_unref(search_result).length)
              ? (_openBlock(), _createElementBlock("tbody", _hoisted_34, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(search_result), (result, index) => {
                    return (_openBlock(), _createElementBlock("tr", { key: index }, [
                      (__props.ikkatuFlg)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_35, [
                            _withDirectives(_createElementVNode("input", {
                              tabindex: "1",
                              type: "checkbox",
                              "onUpdate:modelValue": ($event: any) => ((result.selectFlg) = $event)
                            }, null, 8, _hoisted_36), [
                              [_vModelCheckbox, result.selectFlg]
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (!(_unref(route).path.includes('/newPreOrderList') && __props.ikkatuFlg))
                        ? (_openBlock(), _createElementBlock("td", _hoisted_37, [
                            _createVNode(BtnGreenSmall, {
                              onClick: ($event: any) => (selectSyosi(result)),
                              class: "ModalSyosiList_BtnGreenSmall"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("選択")
                              ]),
                              _: 2
                            }, 1032, ["onClick"])
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("td", null, [
                        _createTextVNode(_toDisplayString(result.syosiCd), 1),
                        _hoisted_38,
                        _createTextVNode(_toDisplayString(result.janCd), 1),
                        _hoisted_39,
                        _createTextVNode(_toDisplayString(result.syuppanSyosiCd), 1)
                      ]),
                      _createElementVNode("td", _hoisted_40, _toDisplayString(result.title), 1),
                      _createElementVNode("td", null, [
                        _createTextVNode(_toDisplayString(result.zsNameDisplay), 1),
                        _hoisted_41,
                        _createTextVNode(_toDisplayString(result.cutting), 1)
                      ]),
                      _createElementVNode("td", null, _toDisplayString(result.releaseDate), 1),
                      _createElementVNode("td", null, _toDisplayString(result.category), 1),
                      _createElementVNode("td", null, _toDisplayString(result.syubetu), 1)
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        (!_unref(search_result).length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_42, " ※検索結果はありません "))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})